<div class="tour-item">
  <span class="tour-item__main">{{ name }}</span>
  <span class="tour-item__minor">{{ additionalInfo }}</span>
</div>
